import { render } from "./P080.vue?vue&type=template&id=3c0adbaf&scoped=true"
import script from "./P080.vue?vue&type=script&lang=js"
export * from "./P080.vue?vue&type=script&lang=js"

import "./P080.vue?vue&type=style&index=0&id=3c0adbaf&scoped=true&lang=css"

import exportComponent from "/home/sage/workspace/sageprice-dev/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c0adbaf"]])

export default __exports__